import { useCallback } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';

import styles from './FilterDeleteModal.module.scss';

interface IFilterDeleteModalProps {
  visible?: boolean;
  name: string;
  onApply: () => void;
  onClose: () => void;
}

export const FilterDeleteModal = ({ visible, name, onApply, onClose }: IFilterDeleteModalProps) => {
  const handleDeleteButtonClick = useCallback(() => {
    onApply();
    onClose();
  }, [onApply, onClose]);

  if (!visible) {
    return null;
  }

  return (
    <Modal modalBodyClassName={styles.ModalBody} visible={visible} onClose={onClose}>
      <ModalHeader title="Подтверждение" color="black" sizeText="small" />
      <ModalBody size="content" border="bottom">
        Удалить сохраненный фильтр {name}?
      </ModalBody>
      <ModalActions>
        <Button text="Удалить" id="deleteButton" color="primary" size="medium" onClick={handleDeleteButtonClick} />
        <Button text="Отменить" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
